import { HistoryItem } from 'client-code/recordings';

import type { TivoPayloadAction } from '../../../core/tivo/tivo-redux-wrapper';
import { TOfferPreview } from '../../../core/types';
import {
    ON_GO_NEXT_PAGE_RECORDING_ACTIVITY,
    ON_GO_PREVIOUS_PAGE_RECORDING_ACTIVITY,
    ON_RETRY_FETCH_RECORDING_ACTIVITY_WHEN_ERROR,
    ON_SET_CARET_VISIBILITY_RECORDING_ACTIVITY,
    ON_SET_CURRENT_PAGE_RECORDING_ACTIVITY,
    ON_SET_GHOST_MODE_RECORDING_ACTIVITY,
    ON_SET_RECORDING_ACTIVITY_API_ERROR,
    ON_SET_RECORDING_ACTIVITY_DATA,
    ON_SET_RECORDING_ACTIVITY_SELECTED_ROW_PREVIEW,
    ON_SET_TOTAL_COUNT_RECORDING_ACTIVITY,
    ON_SET_VERTICAL_POSITION_RECORDING_ACTIVITY,
} from './recordingactivity.types';

export const setRecordingActivityDataAction = (
    recordingItems: HistoryItem[],
): TivoPayloadAction<{ recordingItems: HistoryItem[] }> => ({
    type: ON_SET_RECORDING_ACTIVITY_DATA,
    payload: {
        recordingItems,
    },
});

export const setGhostModeAction = (
    ghostMode: boolean,
): TivoPayloadAction<{ ghostMode: boolean }> => ({
    type: ON_SET_GHOST_MODE_RECORDING_ACTIVITY,
    payload: {
        ghostMode,
    },
});

export const goToRecordingActivityNextPageAction = () => ({
    type: ON_GO_NEXT_PAGE_RECORDING_ACTIVITY,
});

export const goToRecordingActivityPreviousPageAction = (verticalPosition: number) => ({
    type: ON_GO_PREVIOUS_PAGE_RECORDING_ACTIVITY,
    payload: {
        verticalPosition,
    },
});

export const setRecordingActivityApiErrorAction = (
    isError: boolean,
): TivoPayloadAction<{ isError: boolean }> => ({
    type: ON_SET_RECORDING_ACTIVITY_API_ERROR,
    payload: {
        isError,
    },
});

export const setRetryFetchCounterAction = (
    retryFetchCounter: number,
): TivoPayloadAction<{ retryFetchCounter: number }> => ({
    type: ON_RETRY_FETCH_RECORDING_ACTIVITY_WHEN_ERROR,
    payload: {
        retryFetchCounter,
    },
});

export const setVerticalPositionRecordingActivityAction = (
    index: number,
): TivoPayloadAction<{ verticalPosition: number }> => ({
    type: ON_SET_VERTICAL_POSITION_RECORDING_ACTIVITY,
    payload: {
        verticalPosition: index,
    },
});

export const setCurrentPageRecordingActivityAction = (
    currentPage: number,
): TivoPayloadAction<{ currentPage: number }> => ({
    type: ON_SET_CURRENT_PAGE_RECORDING_ACTIVITY,
    payload: {
        currentPage,
    },
});

export const setTotalCountRecordingActivityAction = (
    totalCount: number,
): TivoPayloadAction<{ totalCount: number }> => ({
    type: ON_SET_TOTAL_COUNT_RECORDING_ACTIVITY,
    payload: {
        totalCount,
    },
});

export const setRecordingActivitySelectedRowPreviewAction = (
    selectedRecordingActivityPreviewPromise: Promise<TOfferPreview> | null,
): TivoPayloadAction<{
    selectedRecordingActivityPreviewPromise: Promise<TOfferPreview> | null;
}> => ({
    type: ON_SET_RECORDING_ACTIVITY_SELECTED_ROW_PREVIEW,
    payload: {
        selectedRecordingActivityPreviewPromise,
    },
});

export const setCaretVisibilityAction = (
    isCaretVisible: boolean,
): TivoPayloadAction<{ isCaretVisible: boolean }> => ({
    type: ON_SET_CARET_VISIBILITY_RECORDING_ACTIVITY,
    payload: {
        isCaretVisible,
    },
});
